import { combineReducers } from "@reduxjs/toolkit";
import pagesInfo from "../reducers/pagesInfo";
import aboutInfo from "../reducers/aboutInfo";

const MainReducers = combineReducers({
    Pages: pagesInfo,
    Abouts: aboutInfo
});

export default MainReducers;